import { colors, COLORS } from '@constants/colors';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const MODAL_WIDTH = 760;
  const MODAL_MAX_WIDTH_MOBILE = 760;

  return {
    modalRoot: {
      '& .MuiBackdrop-root': {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      },
    },

    container: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: MODAL_WIDTH,
      background:
        'linear-gradient(135deg, rgba(35, 38, 47, 0.98) 0%, rgba(18, 18, 22, 0.98) 100%)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      backdropFilter: 'blur(12px)',
      borderRadius: '12px',
      maxHeight: '80vh',
      overflow: 'hidden',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '92%',
        maxWidth: MODAL_MAX_WIDTH_MOBILE,
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '18px 20px 14px',
    },
    title: {
      color: COLORS.WHITE,
      fontSize: '16px',
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
    },
    titleCount: {
      color: colors.white_60,
      fontSize: '16px',
      fontWeight: 400,
    },
    closeButton: {
      color: colors.white_60,
      padding: '4px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
    content: {
      padding: '0 16px 12px',
      overflowY: 'auto',
      maxHeight: 'calc(80vh - 140px)',
    },
    brandingList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
    },
    brandingItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 12px',
      backgroundColor: 'rgba(25, 25, 30, 0.6)',
      borderRadius: '8px',
      minHeight: '40px',
      border: '1px solid rgba(255, 255, 255, 0.06)',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease, border-color 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(35, 35, 40, 0.75)',
        borderColor: 'rgba(255, 255, 255, 0.1)',
      },
    },
    brandingName: {
      color: COLORS.WHITE,
      fontSize: '14px',
      fontWeight: 400,
      flex: 1,
    },
    currentLabel: {
      color: colors.white_50,
      fontSize: '14px',
      fontWeight: 400,
    },
    brandingItemRight: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    actionButtons: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      paddingRight: '6px',
      borderRight: '1px solid rgba(255, 255, 255, 0.08)',
    },
    actionButton: {
      width: 36,
      height: 36,
      borderRadius: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        borderColor: 'rgba(255, 255, 255, 0.12)',
      },
    },
    actionIcon: {
      fontSize: 18,
      color: colors.white_60,
    },
    selectButton: {
      width: 36,
      height: 36,
      borderRadius: '8px',
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
        borderColor: 'rgba(255, 255, 255, 0.12)',
      },
    },
    selectButtonActive: {
      backgroundColor: COLORS.GREEN,
      borderColor: 'transparent',
      '&:hover': {
        backgroundColor: COLORS.GREEN,
        borderColor: 'transparent',
      },
    },
    selectIconActive: {
      fontSize: 20,
      color: COLORS.WHITE,
    },
    selectIconInactive: {
      fontSize: 20,
      color: colors.white_60,
    },
    footer: {
      display: 'flex',
      gap: '12px',
      padding: '12px 12px 16px',
    },
    leaveButton: {
      flex: 1,
      color: COLORS.WHITE,
      borderColor: 'rgba(255, 255, 255, 0.2)',
      textTransform: 'none',
      padding: '12px 24px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 500,
      '&:hover': {
        borderColor: 'rgba(255, 255, 255, 0.4)',
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
      },
    },
    createButton: {
      flex: 1,
      backgroundColor: COLORS.MYTAVERSE_BLUE,
      color: COLORS.WHITE,
      textTransform: 'none',
      padding: '12px 24px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: '#3A46C1',
      },
    },

    createContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: MODAL_WIDTH,
      background:
        'linear-gradient(135deg, rgba(35, 38, 47, 0.98) 0%, rgba(18, 18, 22, 0.98) 100%)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      backdropFilter: 'blur(12px)',
      borderRadius: '12px',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '95%',
        maxWidth: MODAL_MAX_WIDTH_MOBILE,
      },
    },
    createHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px 20px 12px',
    },
    createTitle: {
      color: COLORS.WHITE,
      fontSize: '16px',
      fontWeight: 500,
    },
    cardsContainer: {
      display: 'flex',
      gap: '12px',
      padding: '0 20px 20px',
      [breakpoints.down(ScreenSizes.Mobile)]: {
        flexDirection: 'column',
      },
    },
    cardPrimary: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px 20px',
      backgroundColor: COLORS.MYTAVERSE_BLUE,
      borderRadius: '10px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#3A46C1',
        transform: 'translateY(-2px)',
      },
    },
    cardSecondary: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '24px 20px',
      backgroundColor: 'rgba(35, 35, 42, 0.9)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      borderRadius: '10px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(45, 45, 52, 0.9)',
        borderColor: 'rgba(255, 255, 255, 0.15)',
        transform: 'translateY(-2px)',
      },
    },
    cardSecondaryDisabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
      pointerEvents: 'none',
      '&:hover': {
        transform: 'none',
      },
    },
    cardIconWrapper: {
      width: 48,
      height: 48,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      borderRadius: '12px',
      marginBottom: '12px',
    },
    cardIconWrapperSecondary: {
      width: 48,
      height: 48,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      borderRadius: '12px',
      marginBottom: '12px',
    },
    cardIcon: {
      color: COLORS.WHITE,
      fontSize: 24,
    },
    cardTitle: {
      color: COLORS.WHITE,
      fontSize: '14px',
      fontWeight: 600,
      marginBottom: '6px',
      textAlign: 'center',
    },
    cardDescription: {
      color: 'rgba(255, 255, 255, 0.6)',
      fontSize: '12px',
      fontWeight: 400,
      textAlign: 'center',
      lineHeight: 1.4,
    },
    createFooter: {
      padding: '0 20px 20px',
    },
    cancelButtonFull: {
      width: '100%',
      color: COLORS.WHITE,
      backgroundColor: 'rgba(50, 50, 58, 0.9)',
      textTransform: 'none',
      padding: '12px 20px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: 'rgba(60, 60, 68, 0.9)',
      },
    },

    nameContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: MODAL_WIDTH,
      background:
        'linear-gradient(135deg, rgba(35, 38, 47, 0.98) 0%, rgba(18, 18, 22, 0.98) 100%)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      backdropFilter: 'blur(12px)',
      borderRadius: '12px',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '90%',
        maxWidth: MODAL_MAX_WIDTH_MOBILE,
      },
    },
    nameHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px 20px 12px',
    },
    nameHeaderLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    backButton: {
      color: colors.white_60,
      padding: '4px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
    nameTitle: {
      color: COLORS.WHITE,
      fontSize: '16px',
      fontWeight: 500,
    },
    nameContent: {
      padding: '0 20px 20px',
    },
    textField: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'rgba(25, 25, 30, 0.8)',
        borderRadius: '8px',
        color: COLORS.WHITE,
        fontSize: '14px',
        '& fieldset': {
          borderColor: 'rgba(255, 255, 255, 0.1)',
        },
        '&:hover fieldset': {
          borderColor: 'rgba(255, 255, 255, 0.2)',
        },
        '&.Mui-focused fieldset': {
          borderColor: COLORS.MYTAVERSE_BLUE,
        },
      },
      '& .MuiOutlinedInput-input': {
        padding: '12px 14px',
        '&::placeholder': {
          color: colors.white_40,
          opacity: 1,
        },
      },
    },
    characterCount: {
      color: colors.white_40,
      fontSize: '12px',
      textAlign: 'right',
      marginTop: '6px',
    },
    nameFooter: {
      display: 'flex',
      gap: '12px',
      padding: '0 20px 20px',
    },
    cancelButton: {
      flex: 1,
      color: COLORS.WHITE,
      borderColor: 'rgba(255, 255, 255, 0.2)',
      textTransform: 'none',
      padding: '12px 24px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 500,
      '&:hover': {
        borderColor: 'rgba(255, 255, 255, 0.4)',
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
      },
    },
    continueButton: {
      flex: 1,
      backgroundColor: COLORS.MYTAVERSE_BLUE,
      color: COLORS.WHITE,
      textTransform: 'none',
      padding: '12px 24px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: '#3A46C1',
      },
      '&.Mui-disabled': {
        backgroundColor: 'rgba(69, 84, 229, 0.5)',
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },

    selectContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: MODAL_WIDTH,
      background:
        'linear-gradient(135deg, rgba(35, 38, 47, 0.98) 0%, rgba(18, 18, 22, 0.98) 100%)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      backdropFilter: 'blur(12px)',
      borderRadius: '12px',
      maxHeight: '80vh',
      overflow: 'hidden',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: '90%',
        maxWidth: MODAL_MAX_WIDTH_MOBILE,
      },
    },
    selectHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px 20px 12px',
    },
    selectTitle: {
      color: COLORS.WHITE,
      fontSize: '16px',
      fontWeight: 500,
    },
    selectContent: {
      padding: '0 12px 12px',
      overflowY: 'auto',
      maxHeight: 'calc(80vh - 140px)',
    },
    selectList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    selectItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 16px',
      backgroundColor: 'rgba(25, 25, 30, 0.6)',
      borderRadius: '8px',
      cursor: 'pointer',
      border: '1px solid transparent',
      transition: 'all 0.2s ease',
      minHeight: '44px',
      '&:hover': {
        backgroundColor: 'rgba(35, 35, 40, 0.8)',
      },
    },
    selectItemActive: {
      borderColor: COLORS.MYTAVERSE_BLUE,
      backgroundColor: 'rgba(69, 84, 229, 0.1)',
    },
    selectItemName: {
      color: COLORS.WHITE,
      fontSize: '14px',
      fontWeight: 400,
      flex: 1,
    },
    radio: {
      color: colors.white_30,
      padding: '4px',
      '&.Mui-checked': {
        color: COLORS.MYTAVERSE_BLUE,
      },
    },
    selectFooter: {
      display: 'flex',
      gap: '12px',
      padding: '12px 12px 16px',
    },
    useSelectedButton: {
      flex: 1,
      backgroundColor: COLORS.MYTAVERSE_BLUE,
      color: COLORS.WHITE,
      textTransform: 'none',
      padding: '12px 24px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: '#3A46C1',
      },
      '&.Mui-disabled': {
        backgroundColor: 'rgba(69, 84, 229, 0.5)',
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
  };
};
